export async function baseData(endpoint: string, typeRequest: 'GET' | 'POST', otherHeaders?: object) {
  const settings = {
    method: typeRequest,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...otherHeaders
    }
  };
  try {
    const fetchResponse = await fetch(`../api${endpoint}`);    
    const data = await fetchResponse.json();
    return data;
  } catch (error) {
    console.log('error', error);
  }
}

export async function getData(endpoint: string, otherHeaders?: object) {
  return baseData(endpoint, 'GET', otherHeaders);
}

export async function postData(endpoint: string, otherHeaders?: object) {
  return baseData(endpoint, 'POST', otherHeaders);
}